import { UI_SocialLinks } from 'ui/components/3-organisms/SocialLinks/SocialLinks';
import { UI_Footer } from 'ui/components/4-habitats/Footer/Footer';
import { UI_FooterCardList } from 'ui/components/3-organisms/FooterCardList/FooterCardList';
import { useEffect, useState } from 'react';
import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';

interface Props {
	footer: {
		image: Content.Image;
		imageAltText?: string;
		cardLists?: Content.FooterCardList[];
		socialLinks?: Content.SocialLink[];
		bottomLinks?: Content.Link[];
	};
}

export const Footer = ({ footer }: Props) => {
	const useIsMobile = (breakpoint = 768) => {
		const [isMobile, setIsMobile] = useState(false);

		useEffect(() => {
			const handleResize = () => {
				if (typeof window !== 'undefined') {
					setIsMobile(window.innerWidth <= breakpoint);
				}
			};
			handleResize();
			if (typeof window !== 'undefined') {
				window.addEventListener('resize', handleResize);
				return () => window.removeEventListener('resize', handleResize);
			}
		}, [breakpoint]);

		return isMobile;
	};

	const isMobile = useIsMobile(768);
	if (!footer) return null;

	return (
		<CludoComment className="u-top-margin--auto">
			<UI_Footer
				image={footer.image}
				imageAltText={footer.imageAltText}
				bottomLinks={footer.bottomLinks?.map((link) => ({
					url: link.url,
					target: link.target,
					name: link.name,
				}))}
			>
				{footer.cardLists?.map((cardList, index) => (
					<div key={index}>
						<UI_FooterCardList
							cards={cardList.content.cards.map((card) => ({
								heading: card.content.heading,
								text: card.content.text,
								links: card.content.links?.map((link) => ({
									url: link.url,
									target: link.target,
									name: link.name,
								})),
							}))}
						/>
						{/* Only show social links under the first column, when not on mobile */}
						{index === 0 && footer.socialLinks && (
							<UI_SocialLinks
								items={footer.socialLinks.map((item) => ({
									type: item.type,
									url: item.url.url,
									target: item.url.target,
									title: item.url.name,
								}))}
								hide={isMobile}
							/>
						)}
					</div>
				))}
				{/* On mobile, show social links at the end */}
				{footer.socialLinks && (
					<div>
						<UI_SocialLinks
							items={footer.socialLinks.map((item) => ({
								type: item.type,
								url: item.url.url,
								target: item.url.target,
								title: item.url.name,
							}))}
							hide={!isMobile}
						/>
					</div>
				)}
			</UI_Footer>
		</CludoComment>
	);
};
